import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from "@angular/core";
import { Github, Globe, Linkedin, Mail, MapPin, Phone, LucideAngularModule } from "lucide-angular";

@Component({
  selector: "app-resume-one",
  imports: [LucideAngularModule, CommonModule],
  templateUrl: './resume-one.html',
  styleUrl: './resume-one.scss',
})
export class ResumeOneComponent {
 readonly MailIcon = Mail;
  readonly PhoneIcon = Phone
  readonly MapPinIcon = MapPin;
  readonly GlobeIcon = Globe;
  readonly LinkedInIcon = Linkedin
  readonly GithubIcon = Github;

  readonly tel:string = "";

  constructor(@Inject(PLATFORM_ID) private platform: any, @Inject('local-config') private config: any) {
    this.tel = config?.telephone;
  }
  
  expertiseAreas: string[] = [
    "Computer Vision & Biometric Systems",
    "Natural Language Processing & Transformer-based Models",
    "Machine Learning & Deep Learning",
    "Remote Sensing & Geospatial Analysis"
  ];

  technicalSkills: string[] = [
    "Docker", "Kubernetes", "Python",
    "C#", "Terraform", "ESRI ArcGIS Pro",
    "Github-Workflows", "ArgoCD", "PyTorch",
    "Transformers", "TensorFlow", "Scikit-learn",
    "Pandas", "Numpy", "Matplotlib",
    "Seaborn", "Cassandra", "PostgresQL",
    "Confluent Kafka", "Rook-Ceph", "Milvus",
    "FastAPI", "OpenCV", "Ray", "Git",
    "Rastervision", "Mediapipe", "gRPC",
    "Protobuf", "LangChain", "OnnxRuntime",
    "Sockets", "Linux", "Redis", "Prometheus",
    "Grafana", "Ansible"
  ];

  technicalSkillGroups = [
    {
      title: "Programming & Core",
      items: [
        "Python", "C#", "Linux", "Git", "Sockets"
      ]
    },
    {
      title: "Machine Learning / Deep Learning",
      items: [
        "PyTorch", "TensorFlow", "Transformers",
        "Scikit-Learn", "Onnx-Runtime", "DeepSpeed",
        "FairScale"
      ]
    },
    {
      title: "Computer Vision & Imaging",
      items: [
        "OpenCV", "Mediapipe", "Rastervision", "GEE"
      ]
    },
    {
      title: "NLP & LLM Ecosystem",
      items: [
        "LangChain", "Unsloth", "LLMA"
      ]
    },
    {
      title: "DevOps / MLOps",
      items: [
        "Docker", "Kubernetes", "Terraform",
        "GitHub Workflows", "ArgoCD",
        "Ansible", "Prometheus", "Grafana"
      ]
    },
    {
      title: "Distributed Systems",
      items: [
        "Confluent Kafka", "gRPC", "Protobuf",
        "Rook-Ceph", "Apache Spark", "Ray"
      ]
    },
    {
      title: "Web Frameworks & APIs",
      items: [
        "ASP.NET Core", "FastAPI", "Flask", "Angular"
      ]
    },
    {
      title: "Data & Databases",
      items: [
        "Pandas", "Numpy", "Cassandra",
        "PostgreSQL", "Redis", "Milvus",
        "Qdrant", "Firebase", "Copernicus"
      ]
    },
    {
      title: "Visualization",
      items: [
        "Matplotlib", "Seaborn", "Plotly"
      ]
    },
    {
      title: "GIS & Remote Sensing Tools",
      items: [
        "ESRI ArcGIS Pro", "QGIS"
      ]
    }
  ];

}
